import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Madiwalappa </span>
            from <span className="purple"> Bijapur, India.</span>
            <br />
            I am currently employed as a DevOps in Minfy.
            <br />
            I have completed my BE in Electronic and Communication
            <br />
            <br />
            Apart from DevOps, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Madiwalappa</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
